import { ErrorReportingDevtools } from '../types/ErrorReportingDevtools';

/**
 * Prints a quick reference of all `window.errorReporting` commands to the
 * console.
 */
export const createHelpDevtool = (): ErrorReportingDevtools['help'] => {
  return (): void => {
    console.info(
      [
        'errorReporting devtools - available commands:',
        "  errorReporting.triggerError('throw' | 'async-throw' | 'unhandled-promise' | 'console-error' | 'manual-exception' | 'manual-message' | 'render-crash', message?)",
        '  errorReporting.getScope()                       // user, tags, extra, breadcrumbs',
        '  errorReporting.listBreadcrumbs(filter?)        // pretty-print the breadcrumb timeline',
        "  errorReporting.breadcrumb('hello', { foo: 'bar' })",
        "  errorReporting.simulateNetworkError('/v1/users', 500, 'POST')",
        '  errorReporting.flush(timeout?)                 // flush pending events',
        '  errorReporting.clearScope()                    // reset user/tags/extras/breadcrumbs',
      ].join('\n'),
    );
  };
};
